<template>
  <p class="text-sm text-base-700">
    <span
      :class="[
        'diff-sign',
        diffClass,
      ]"
    >
      <slot name="value" />
    </span>
    &nbsp;<slot name="text" />
  </p>
</template>

<script>
export default {
  props: {
    diffClass: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style lang="postcss" scoped>
.diff-sign.positive::before {
  content: '+ ';
}
.diff-sign.positive {
  @apply text-primary-500;
  &.frequency,
  &.disparitiesScoreMonth,
  &.disparities {
    @apply text-complementary-500;
  }
}
.diff-sign.negative::before {
  content: '- ';
}
.diff-sign.negative {
  @apply text-complementary-500;
  &.frequency,
  &.disparitiesScoreMonth,
  &.disparities {
    @apply text-primary-500;
  }
}
</style>
